import React from "react";

import WeekdayTable from "components/WeekdayTable";
import DailyMealInput from "components/school_money/dinners/DailyMealInput";

export default class WeeklyMealInput extends React.Component {
  
  render() {
    return (
      <WeekdayTable cssBlockName="weekly-meal-input">
        { (weekdayIndex, weekdayName) => (
          <DailyMealInput
            key={weekdayIndex}
            weekdayIndex={weekdayIndex}
            weekdayName={weekdayName}
            dinnerBookingID={this.props.dinnerBookingID}
            onReadOnlyClick={this.props.onReadOnlyClick}
          />
        ) }
      </WeekdayTable>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/WeeklyMealInput.js